/* eslint-disable no-param-reassign */
import {type PayloadAction, createSlice} from '@reduxjs/toolkit';

export type Ibreadcrumb = {
	label: string;
	url: string;
};

export const initialState: Ibreadcrumb[] = [
	{label: 'Inicio', url: '/'},
];

export const breadcrumbSlice = createSlice({
	name: 'breadcrumbs',
	initialState,
	reducers: {
		setBreadcrumbs: (state, action: PayloadAction<Ibreadcrumb[]>) => {
			state.splice(0, state.length, ...action.payload);
		},
		resetBreadcrumb: (state) => {
			state.splice(0, state.length);
		},
		setBreadCrumbsChild: (state, action: PayloadAction<Ibreadcrumb>) => {
			// Solo se debe dejar el primer elemento y se agrega el nuevo elemento
			state.splice(1, state.length - 1, action.payload);
		},
		addBreadcrumb: (state, action: PayloadAction<Ibreadcrumb>) => {
			state.push(action.payload);
		},
	},
});

export default breadcrumbSlice.reducer;

export const {setBreadcrumbs, addBreadcrumb} = breadcrumbSlice.actions;
